import { useState } from 'react';
import { Dropdown, Button, Select, Space } from 'antd';
import {
    GroupOutlined,
    PlusOutlined,
    DeleteOutlined,
    DownOutlined,
} from '@ant-design/icons';
import { columnDefs } from '../AssetManagerContext';
import { useFilter } from '../AssetManagerContext';

export function GroupBy() {
    const [open, setOpen] = useState(false);
    const [groups, setGroups] = useState([]);
    const { setGroupBy } = useFilter();

    const onApplyGroups = (groups) => setGroupBy(groups);

    const addGroup = () => {
        setGroups([...groups, { field: null, order: 'asc' }]);
    };

    const removeGroup = (index) => {
        setGroups(groups.filter((_, i) => i !== index));
    };

    const updateGroup = (index, key, value) => {
        const next = [...groups];
        next[index][key] = value;
        setGroups(next);
    };

    const handleApply = () => {
        onApplyGroups(groups.filter((g) => g.field));
        setOpen(false);
    };

    const handleClear = () => {
        setGroups([]);
        onApplyGroups([]);
    };

    const overlay = (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                background: 'white',
                border: '1px solid #f0f0f0',
                borderRadius: 4,
                minWidth: 320,
                padding: 8,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <div
                style={{
                    maxHeight: 300,
                    overflowY: 'auto',
                    marginBottom: 8,
                }}
            >
                {groups.map((group, index) => (
                    <Space
                        key={index}
                        style={{
                            display: 'flex',
                            marginBottom: 8,
                            width: '100%',
                            justifyContent: 'space-between',
                        }}
                        align="center"
                    >
                        {/* Field selector */}
                        <Select
                            placeholder="Field"
                            value={group.field}
                            onChange={(val) => updateGroup(index, 'field', val)}
                            style={{ width: 180 }}
                            popupMatchSelectWidth={false}
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                (option?.label ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            options={Object.keys(columnDefs || {})
                                .sort((a, b) => a.localeCompare(b))
                                .map((c) => ({
                                    label: c,
                                    value: c,
                                }))}
                        />

                        {/* Sort order */}
                        <Select
                            placeholder="Order"
                            value={group.order}
                            onChange={(val) => updateGroup(index, 'order', val)}
                            style={{ width: 100 }}
                            popupMatchSelectWidth={false}
                            options={[
                                { label: 'Ascending (A→Z)', value: 'asc' },
                                { label: 'Descending (Z→A)', value: 'desc' },
                            ]}
                        />

                        <Button
                            type="text"
                            icon={<DeleteOutlined />}
                            onClick={() => removeGroup(index)}
                        />
                    </Space>
                ))}
            </div>

            {/* Add Group button */}
            <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={addGroup}
                style={{ marginBottom: 8 }}
                block
            >
                Add Group
            </Button>

            {/* Footer */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderTop: '1px solid #f0f0f0',
                    paddingTop: 8,
                }}
            >
                <Button size="small" onClick={handleClear}>
                    Clear
                </Button>
                <Button type="primary" size="small" onClick={handleApply}>
                    Apply
                </Button>
            </div>
        </div>
    );

    return (
        <Dropdown
            dropdownRender={() => overlay}
            open={open}
            onOpenChange={setOpen}
            trigger={['click']}
            placement="bottomLeft"
        >
            <Button icon={<GroupOutlined />}>
                Group By <DownOutlined />
            </Button>
        </Dropdown>
    );
}
